import React from 'react';
import styled from 'styled-components';
import {getColors} from '../utils/styling';

const allColors = ({theme}) => {
  return getColors(theme);
};

const ObfuscatedLinkStyled = styled('button')`
  border: none;
  background-color: transparent;
  color: ${props => allColors(props).white};
  font-size: 16px;
  text-align: left;
  cursor: pointer;
`;

export const ObfuscatedLink = ({url, label}) => {
  return (
      <ObfuscatedLinkStyled onClick={() => {
        window.location = url;
      }}>{label}</ObfuscatedLinkStyled>
  );
};
